//SuperAdmin Tournament 확인완료
//Tournament 확인완료

import { API_V2 } from './apiVersion';

export const TOURNAMENT_ENDPOINTS = {
  LIST:
    `${API_V2}/tournaments`,

  RESERVE: (
    tournamentId: number,
  ) =>
    `${API_V2}/tournaments/${tournamentId}/participants`,

  MY_RESERVATIONS:
  `${API_V2}/users/me/tournaments/reservations`,

  
  SUPERADMIN: {
    CREATE:
      `${API_V2}/superadmin/tournaments`,

    PARTICIPANTS: (
      tournamentId: number,
    ) =>
      `${API_V2}/superadmin/tournaments/${tournamentId}/participants`,

    PARTICIPANT: (
      tournamentId: number,
      participantId: number,
    ) =>
      `${API_V2}/superadmin/tournaments/${tournamentId}/participants/${participantId}`,
  },
} as const;